import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuncionalidadControl } from '../../_models/funcionalidad-control';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { ProductoEstadoRelacionService } from '../../_services/producto-estado-relacion.service';
import { ListaService } from '../../_services/lista.service';
import { ProductoEstadoRelacionCausalService } from '../../_services/producto-estado-relacion-causal.service';
import { TipoCausalCausalSolicitudService } from '../../_services/tipo-causal-causal-solicitud.service';
import { FuncionalidadesService } from '../../_services/funcionalidades.service';
import { ProductoEstadoRelacionNotificacionService } from '../../_services/producto-estado-relacion-notificacion.service';
import { NotificacionesService } from '../../_services/notificaciones.service';
import { forkJoin } from 'rxjs';
import { CanalService } from '../../_services/canal.service';
import { EstadoService } from '../../_services/estado.service';
import { ConfiguracionesCanales } from '../../_models/configuraciones-canales';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfiguracionesCanalesService } from '../../_services/configuraciones-canales.service';
import { Location } from '@angular/common';
import moment from 'moment';
import 'moment/locale/es';
import { FlujoVentaPaso } from '../../_models/flujo-venta-paso';
import { ConfiguracionCanalFlujoVentaPaso } from '../../_models/configuracion-canal-flujo-venta-paso';
import { FlujoVentaPasoService } from '../../_services/flujo-venta-paso.service';
import { ConfiguracionCanalFlujoVentaPasoService } from '../../_services/configuracion-canal-flujo-venta-paso.service';
import {CodigosPoliticas, Pasos} from '../../_enums/enum';
import { ConfiguracionCanalFlujoVentaPasoControlProducto } from '../../_models/configuracion-canal-flujo-venta-paso-control-producto';
import { Producto } from '../../_models/producto';
import { FlujoVentaPasoControl } from '../../_models/flujo-venta-paso-control';
import { FlujoVentaPasoControlService } from '../../_services/flujo-venta-paso-control.service';
import { ProductoService } from '../../_services/producto.service';
import { ConfiguracionCanalFlujoVentaPasoControlProductoService } from '../../_services/configuracion-canal-flujo-venta-paso-control-producto.service';
import {Politica} from '../../_models/politica';
import {ConfiguracionCanalFlujoVentaPasoPoliticaProducto} from '../../_models/configuracion-canal-flujo-venta-paso-politica-producto';
import {PoliticaService} from '../../_services/politica.service';
import {ConfiguracionCanalFlujoVentaPasoPoliticaProductoService} from '../../_services/configuracion-canal-flujo-venta-paso-politica-producto.service';
import {PoliticaVinculacion} from '../../_models/politica-vinculacion';
import {PoliticaOficina} from '../../_models/politica-oficina';

@Component( {
  selector: 'app-canal-estado-paso-politica-producto',
  templateUrl: 'canal-estado-paso-politica-producto.component.html'
} )

export class CanalEstadoPasoPoliticaProductoComponent implements OnInit {

  @Input() configuracionCanalPaso: ConfiguracionCanalFlujoVentaPaso;
  @Input() editar: true;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  formularioPasosControles: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  carInformacionInicial = true;
  politicas: Politica[] = [];
  productos: Producto[] = [];
  listaPoliticas: SelectItem[] = [];
  listaProductos: SelectItem[] = [];
  listaCanalPasoPoliticasProductos: any[] = [];
  listaCanalPasoPoliticasProductosTodos: ConfiguracionCanalFlujoVentaPasoPoliticaProducto[] = [];
  carTabla = true;
  showTable = false;
  controlProductoEditar: any;
  controlEdicion: string;

  get fControls() {
    return this.formularioPasosControles.controls;
  }

  constructor( private navServicio: NavService,
               private conServicio: ConfirmationService,
               private proEstadoCambioServicio: ProductoEstadoRelacionService,
               private fb: FormBuilder,
               private lisServicio: ListaService,
               private proEstadoRelacionCausalServicio: ProductoEstadoRelacionCausalService,
               private tipCausalesService: TipoCausalCausalSolicitudService,
               private funServicio: FuncionalidadesService,
               private proEstadoRelacionNotificacionServicio: ProductoEstadoRelacionNotificacionService,
               private notServicio: NotificacionesService,
               private canalService: CanalService,
               private estadoService: EstadoService,
               private activeRoute: ActivatedRoute,
               private configCanalService: ConfiguracionesCanalesService,
               private location: Location,
               private fluVentaPasoService: FlujoVentaPasoService,
               private canalPasoService: ConfiguracionCanalFlujoVentaPasoService,
               private productoService: ProductoService,
               private configCanalFluVentaPasoPoliticaProdService: ConfiguracionCanalFlujoVentaPasoPoliticaProductoService,
               private politicaService: PoliticaService,
               ) {
  }

  ngOnInit(): void {
    this.cargarEncabezadoTabla();
    this.cargarDatos();
  }

  cargarEncabezadoTabla() {
    this.columnas = [
      { field: 'politica', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_POLITICA' ), sort: true },
      { field: 'tipoPolitica', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_TIPOPOLITICA' ), sort: true },
      { field: 'incumplimiento', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_INCUMPLIMIENTO' ), sort: true },
      { field: 'productos', header: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.LBL_PRODUCTO' ), sort: true }
    ];
    if ( this.editar ) {
      this.columnas.push({ field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false });
    }
  }

  cargarDatos() {
    forkJoin(
      this.politicaService.obtenerPoliticaPorCodigoHabilitada(CodigosPoliticas.PoliticasCredito),
      this.productoService.listado()
    ).subscribe(async ([politicas, productos]) => {
      productos = productos.sort(function (a, b) {
        return a.orden - b.orden;
      });
      this.productos = productos;
      this.politicas = politicas;

      productos.map( p => {
        const item = { label: p.nombre, value: p.idProducto };
        this.listaProductos.push(item);
      });
      await this.cargarDatosTabla();

    });
  }

  async cargarDatosTabla() {
    this.showTable = false;
    this.carInformacionInicial = true;
    this.configCanalFluVentaPasoPoliticaProdService.listadoPorIdConfiguracionCanalPaso(this.configuracionCanalPaso.idConfiguracionCanalFlujoVentaPaso)
      .subscribe( canalPasoPoliticas => {
        this.listaCanalPasoPoliticasProductosTodos = canalPasoPoliticas;
      this.crearListaCustom();
      this.listaPoliticas = [];
      this.politicas.map( c => {
        const existeHabilitado = this.listaCanalPasoPoliticasProductos.find( x => x.idPolitica === c.idPolitica );
        if ( !existeHabilitado ) {
          const item = { label: c.nombre, value: c.idPolitica };
          this.listaPoliticas.push(item);
        }
      });
      this.cargarFormulario();
    });
    //return true;
  }

  crearListaCustom() {
    this.listaCanalPasoPoliticasProductos = [];
    this.listaCanalPasoPoliticasProductosTodos.map( cpcp => {
      if ( cpcp.indicadorHabilitado ) {
        const addedIndex = this.listaCanalPasoPoliticasProductos.findIndex( x => x.idPolitica === cpcp.idPolitica );
        if ( addedIndex > -1 ) {
          this.listaCanalPasoPoliticasProductos[addedIndex].productos.push(cpcp.idProducto);
          this.listaCanalPasoPoliticasProductos[addedIndex].producto += ' - ' + cpcp.producto;
        } else {
          const objCustom: any = Object.assign({}, cpcp);
          objCustom.productos = [ cpcp.idProducto ];
          objCustom.producto = cpcp.producto;
          this.listaCanalPasoPoliticasProductos.push(objCustom);
        }
      }
    });
  }

  cargarFormulario() {
    this.formularioPasosControles = this.fb.group( {
      idPolitica: [ this.controlProductoEditar ? this.controlProductoEditar.idPolitica  : null, [Validators.required] ],
      idProductos: [ this.controlProductoEditar ? this.controlProductoEditar.productos  : null, [Validators.required] ]
    } );
    this.showTable = true;
    this.carInformacionInicial = false;
    this.carTabla = false;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formularioPasosControles.valid ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.MSG_GUARDARPRODUCTOSCONTROL' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'productos-controles',
        accept: () => {
          this.guardarPasosConfiguracionCanalPoliticaProducto();
        },
        reject: () => {
        }
      } );
    }
  }


  guardarPasosConfiguracionCanalPoliticaProducto() {

    this.guardando = true;
    const formulario = this.formularioPasosControles.value;
    const pol = this.politicas.find( x => x.idPolitica === formulario.idPolitica );
    const listTemp: ConfiguracionCanalFlujoVentaPasoPoliticaProducto[] = [];

    if ( formulario.idProductos ) {
      formulario.idProductos.map( sud => {
        let temp = {} as ConfiguracionCanalFlujoVentaPasoPoliticaProducto;
        const pro = this.productos.find( x => x.idProducto === sud );
        temp.idPolitica = formulario.idPolitica;
        temp.idProducto = sud;
        temp.idConfiguracionCanalFlujoVentaPaso = this.configuracionCanalPaso.idConfiguracionCanalFlujoVentaPaso;
        temp.indicadorHabilitado = true;
        if (pol) {
          temp.codigoPolitica = pol.codigo;
          temp.politica = pol.nombre;
          temp.indicadorAlerta = pol.indicadorAlerta;
          temp.indicadorDescarta = pol.indicadorDescarta;
          temp.indicadorPoliticaModalidad = pol.indicadorPoliticaModalidad;
          temp.indicadorPoliticaProducto = pol.indicadorPoliticaProducto;
        }
        if(pro){
          temp.producto = pro.nombre;
          temp.codigoProducto = pro.codigo;
        }
        const existe = this.listaCanalPasoPoliticasProductosTodos.find( x => x.idProducto === temp.idProducto && x.idPolitica === temp.idPolitica);
        if(existe) {
          temp.idConfiguracionCanalFVPasoPoliticaProducto = existe.idConfiguracionCanalFVPasoPoliticaProducto;
        }
        listTemp.push(temp);
      });
      this.listaCanalPasoPoliticasProductosTodos.forEach( e => {
        if ( e.idConfiguracionCanalFVPasoPoliticaProducto &&  e.indicadorHabilitado
          && !listTemp.find( y => y.idProducto === e.idProducto ) && e.idPolitica === formulario.idPolitica  ) {
          e.indicadorHabilitado = false;
          listTemp.push( e );
        }
      } );
    }
    if ( listTemp.length > 0 ) {
      this.configCanalFluVentaPasoPoliticaProdService.bulk(listTemp).subscribe( destino => {
        this.formularioPasosControles.reset();
        this.submitted = false;
        this.guardando = false;
        this.cargarDatosTabla();
        if ( this.controlProductoEditar ) {
          this.controlProductoEditar.productos = listTemp.filter( x => x.indicadorHabilitado).map(item => item.idProducto);
          this.showMessage('LBL_INFORMACION', 'Se han actualizado la configuración de forma exitosa!', 'success');
        } else {
          this.showMessage('LBL_INFORMACION', 'Se han guardado la configuración de forma exitosa!', 'success');
        }
      }, error => {
        this.cargarFormulario();
        this.guardando = false;
        this.navServicio.setMesage( 3 );
      } );
    } else {
      this.navServicio.setMesage( 3 );
      this.guardando = false;
    }
  }

  private showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.navServicio.setMesage( 0, {
      severity: severity, summary: this.navServicio.buscarMensaje( titulo ),
      detail: this.navServicio.buscarMensaje( mensaje )
    } );
  }

  editarProductosControl(record: any) {
    this.controlProductoEditar = record;
    this.controlEdicion = record.politica;
    this.cargarFormulario();
    this.formularioPasosControles.markAsDirty();
  }

  inhabilitarProductosControl(record: any) {
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.MSG_INHABILITARPRODUCTOSCONTOL' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'productos-controles',
      accept: () => {
        const listaInhabilitar = this.armarListaInhabilitar(record.idPolitica, record.productos);
        this.configCanalFluVentaPasoPoliticaProdService.bulk(listaInhabilitar).subscribe( resp => {
          this.formularioPasosControles.reset();
          this.showMessage('LBL_INFORMACION', 'Se ha eliminado la configuración de forma exitosa!', 'success');
          this.controlEdicion = null;
          this.controlProductoEditar = null;
          this.cargarDatosTabla();
        });
      },
      reject: () => {
      }
    } );
  }

  armarListaInhabilitar(idPolitica: string, idProductos: string[]) {
    const listaReturn = [];
    idProductos.map( idProducto => {
      const existe = this.listaCanalPasoPoliticasProductosTodos.find( x => x.idProducto === idProducto && x.idPolitica === idPolitica);
      if ( existe ) {
        existe.indicadorHabilitado = false;
      }

      listaReturn.push(existe);
    });
    return listaReturn;
  }


  cancelarEdicion(dirtyForm: boolean) {
    if ( dirtyForm ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'CONFIGURACIONCANALESESTADO.MSG_CANCELAREDICION' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'productos-controles',
        accept: () => {
          this.controlProductoEditar = null;
          this.controlEdicion = null;
          this.formularioPasosControles.reset();
        },
        reject: () => {
        }
      } );
    } else {
      this.controlProductoEditar = null;
      this.controlEdicion = null;
      this.formularioPasosControles.reset();
    }
  }




}
